import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactSection from '../components/ContactSection';
import SEO from '../components/SEO';

export default function ContactPage() {
  return (
    <div>
      <SEO
        title="Contact Us — Welding Electrodes Sales & Support"
        description="Get in touch with Prakash Electrodes Private Limited for pricing, samples, technical support, or bulk orders. Located in Kota, Rajasthan."
        path="/contact"
      />
      <Navbar />

      <section className="relative bg-[#0b0b0d] text-white pt-40 pb-24 overflow-hidden noise">
        <div className="absolute inset-0 bg-grid opacity-30" />
        <div className="absolute right-0 top-0 h-96 w-96 rounded-full bg-amber-500/20 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-400 mb-4">
            — Contact
          </div>
          <h1 className="font-display text-5xl lg:text-6xl font-semibold leading-[1.05] max-w-3xl">
            We value your questions and feedback.
          </h1>
          <p className="mt-6 text-white/70 max-w-2xl text-lg leading-relaxed">
            Reach out to us for any inquiries or support. Our team is here to assist you
            promptly.
          </p>
        </div>
      </section>

      <ContactSection compact />

      {/* Map */}
      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="rounded-2xl overflow-hidden border border-neutral-200 aspect-[21/9]">
            <iframe
              title="Prakash Electrodes Private Limited Location"
              src="https://www.google.com/maps?q=Prakash+Electrodes+Private+Limited,+F-147+IPIA+Road+No.+5,+Kota,+Rajasthan&ll=25.1339661,75.8602741&z=17&output=embed"
              width="100%"
              height="100%"
              loading="lazy"
              style={{ border: 0 }}
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
          <div className="mt-3 text-center">
            <a
              href="https://www.google.com/maps/place/Prakash+Electrodes+Private+Limited-+Leading+Mfg.+of+MS+Wire+Nails,Binding+wire,HB+Wire+%26+Welding+Electrodes/@25.1339661,75.8602741,17z/data=!4m14!1m7!3m6!1s0x396f851b3f5af737:0xb345a5047caace7b!2sPrakash+Electrodes+Private+Limited"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-neutral-600 hover:text-amber-600 transition-colors"
            >
              Open in Google Maps →
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
